import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import ProductCardOrganism from '~/components/_next/organisms/ProductCardOrganism.vue';
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import { ProductAttributes } from '~/types/ProductEnums';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'SlimRelatedProductsCarousel',
  props: {
    relatedProducts: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useLocalization = useLocalization(),
      country = _useLocalization.country;
    var pairs = ref([]);
    var isSinglePairs = computed(function () {
      return pairs.value && pairs.value.length <= 1;
    });
    var availableRelatedProducts = computed(function () {
      return props.relatedProducts.filter(function (product) {
        var _product$attributesRa, _availableCountryAttr;
        var availableCountryAttr = (_product$attributesRa = product.attributesRaw) === null || _product$attributesRa === void 0 ? void 0 : _product$attributesRa.find(function (attr) {
          return attr.name === ProductAttributes.availableInCountries;
        });
        var availableCountries = availableCountryAttr === null || availableCountryAttr === void 0 ? void 0 : (_availableCountryAttr = availableCountryAttr.value) === null || _availableCountryAttr === void 0 ? void 0 : _availableCountryAttr.map(function (val) {
          return val.key;
        });
        return (availableCountries === null || availableCountries === void 0 ? void 0 : availableCountries.includes(country)) || (availableCountries === null || availableCountries === void 0 ? void 0 : availableCountries.includes('ALL'));
      });
    });
    var productSlug = function productSlug(product) {
      return (product === null || product === void 0 ? void 0 : product._slug) || '';
    };
    watch(availableRelatedProducts, function (newVal) {
      pairs.value = divideIntoPairs(newVal);
    }, {
      immediate: true
    });

    /**
     * Splits an array into pairs (biomes).
     * @param {Array} dataArray - The array of data to split.
     * @returns {Array} - A new array containing pairs of data.
     */
    function divideIntoPairs(dataArray) {
      var pairsArray = [];
      for (var i = 0; i < dataArray.length; i += 2) {
        pairsArray.push(dataArray.slice(i, i + 2));
      }
      return pairsArray;
    }
    return {
      __sfc: true,
      props: props,
      country: country,
      pairs: pairs,
      isSinglePairs: isSinglePairs,
      availableRelatedProducts: availableRelatedProducts,
      productSlug: productSlug,
      divideIntoPairs: divideIntoPairs,
      ProductCardOrganism: ProductCardOrganism,
      NativeCarousel: NativeCarousel
    };
  }
});